import React from 'react'
import styles from './EmbedViewer.scss'
import blockSizes from '../../../App/blockSizes.scss'

export const EmbedViewer = ({ block }) => {
  const data = block.getData()

  const src = data.get('src')
  const ratio = data.get('ratio')
  const mediaType = data.get('mediaType') || 'iframe'

  let embed
  switch (mediaType) {
    case 'iframe':
      const height = data.get('height', 480)

      let dstyle = {}

      if (ratio) {
        dstyle[ 'paddingTop' ] = `${100 * ratio}%`
      } else {
        dstyle[ 'paddingTop' ] = `${height}px`
      }

      embed = (
        <div className={styles.EmbedViewer} style={dstyle}>
          <iframe src={src} frameBorder='0' />
        </div>
      )
      break

    case 'gif':
      embed = <img style={{ maxWidth: '100%' }} src={src} />
      break
    case 'mp4':
      embed = (
        <video style={{ maxWidth: '100%' }} autoPlay muted loop>
          <source src={src} type='video/mp4' />
        </video>
      )
      break
  }

  return (
    <div className={blockSizes.normalBlock} style={{ textAlign: 'center' }}>
      {embed}
    </div>
  )
}
